import { render, staticRenderFns } from "./adminComplaintDetailList.vue?vue&type=template&id=ea7cb0c6&scoped=true"
import script from "./adminComplaintDetailList.vue?vue&type=script&lang=js"
export * from "./adminComplaintDetailList.vue?vue&type=script&lang=js"
import style0 from "./adminComplaintDetailList.vue?vue&type=style&index=0&id=ea7cb0c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7cb0c6",
  null
  
)

export default component.exports